import { tag_list_item } from "@/app/typing/tags";
import { useEffect, useRef, useState } from "react";
import { ChatEntryList } from "./chatEntryList";
import { adminDeleteTags } from "@/api";
import { scrollIntoContainer } from "@/components/scrollUtils";

const ChatTagList = (params: { tag_list: tag_list_item[], tool_use_id?: string, intent?: string }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [highlightedId, setHighlightedId] = useState<number | null>(null);

    useEffect(() => {
        const handleCitationHover = (e: CustomEvent) => {


            if (e.detail.citationType == "tag") {
                const { tag_id, action } = e.detail;

                if (action === 'enter') {
                    setHighlightedId(tag_id);
                } else if (action === 'leave') {
                    setHighlightedId(null);
                }

            }
        };

        const handleCitationClick = (e: CustomEvent) => {

            const { tag_id } = e.detail;

            if (e.detail.citationType == "tag") {

                const element = containerRef.current?.querySelector(`[data-item-id="${tag_id}"]`);
                if (element) {
                    setHighlightedId(tag_id);
                    setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
                }

            }

        };

        document.addEventListener('citation-hover', handleCitationHover as EventListener);
        document.addEventListener('citation-click', handleCitationClick as EventListener);

        return () => {
            document.removeEventListener('citation-hover', handleCitationHover as EventListener);
            document.removeEventListener('citation-click', handleCitationClick as EventListener);
        };
    }, [params.tool_use_id]);


    return (
        <div className="w-full" ref={containerRef}>
            <ChatEntryList
                items={params.tag_list.map(tag => ({ ...tag }))}
                object_type={`tag`}
                intent={params.intent}
                extractDisplayValue={(tag) => tag.name}
                extractId={(tag) => tag.id}
                deleteFunction={(ids) => adminDeleteTags({ body: { ids } })}
                routePath="/workspace/tags"
                containerClassName="h-full w-full max-h-[16em] overflow-y-auto"
                debugMessage="mount tags"
                highlightedId={highlightedId}
            />
        </div>
    );
};

export default ChatTagList